import { classes } from '../constants';

/**
 * FiltersComplex class manages the coordination of multiple disclosure filters.
 */
export class FiltersComplex {
  constructor() {
    this.filters = document.querySelectorAll('[data-js-filter-disclosure]');
    this.checkboxes = [];
    this.resetlink = document.querySelector('[data-js-filter-reset]');
    this.addEventListeners();
  }

  /**
   * Adds event listeners to filter components and the reset link.
   */
  addEventListeners() {
    [...this.filters].forEach((el) => {
      this.checkboxes.push(
        ...document.getElementsByName(
          el.getAttribute('data-js-filter-disclosure')
        )
      );
    });

    [...this.checkboxes].forEach((el) => {
      el.addEventListener('change', (e) => {
        this.filterContent();
      });
    });

    if (this.resetlink) {
      this.resetlink.addEventListener('click', (e) => this.resetFilters());
    }
  }

  /**
   * Filter content based on selected checkbox values.
   */
  filterContent() {
    const selectors = [];

    this.filters.forEach((filter) => {
      selectors.push(
        this.getFilterValues(filter.getAttribute('data-js-filter-disclosure'))
      );
    });

    this.setActiveTarget(selectors);
  }

  /**
   * Gets filter values from the checkboxes associated with a specific filter.
   * @param {string} name - The name attribute of the filter element.
   * @returns {string} - A comma-separated string of filter selectors.
   */
  getFilterValues(name) {
    const markedCheckbox = document.getElementsByName(name);
    let selectors = [];

    markedCheckbox.forEach((checkbox) => {
      if (checkbox.checked && checkbox.value) {
        selectors.push(`[data-js-${name}~="${checkbox.value}"]`);
      }
    });

    return selectors.join(', ');
  }

  /**
   * Show items based on the provided filter selectors.
   * @param {string[]} selectors - An array of filter selectors.
   * @param {boolean} checkNoResults - Whether to check for no results and display a message.
   */
  setActiveTarget(selectors = [], checkNoResults = true) {
    const hasSingleSelector =
      Array.isArray(selectors) && selectors.length === 1 && selectors[0] !== '';
    const hasMultipleSelectors =
      Array.isArray(selectors) && selectors.length > 1;
    const all = document.querySelectorAll('[data-js-filter-item]');
    let targets = [...all];

    if (hasSingleSelector) {
      targets = document.querySelectorAll(selectors[0]);
    } else if (hasMultipleSelectors) {
      /* get items for each different filter / category */
      const filterTargets = selectors.map((selector) => {
        return selector ? [...document.querySelectorAll(selector)] : [...all];
      });

      /* only get interesection of each filter */
      targets = filterTargets.reduce(
        (commonElements, currentArray) =>
          commonElements.filter((element) => currentArray.includes(element)),
        filterTargets[0]
      );
    }

    [...all].forEach((item) =>
      item.parentNode.classList.remove(classes.active)
    );
    [...targets].forEach((item) =>
      item.parentNode.classList.add(classes.active)
    );

    if (checkNoResults && targets.length === 0) {
      this.setNoResults();
    }
  }

  /**
   * Set all filters back to 'all' option.
   */
  resetFilters() {
    [...this.filters].forEach((el) => {
      el.dispatchEvent(new Event('reset-filter'));
    });

    this.setActiveTarget([], false);
  }

  /**
   * Show empty results element.
   */
  setNoResults() {
    this.setActiveTarget(['.filter-no-results'], false);
  }
}

if (document.querySelectorAll('[data-js-filter-disclosure]').length) {
  const filters = new FiltersComplex();
}
